export default "__VITE_ASSET__ClW5C9e0__"